// extracted by mini-css-extract-plugin
export default {"card":"JZ-z","carouselContainer":"KZ-z","carouselContent":"LZ-z"};